import template from './event.html';
import controller from './event.controller';
import './event.scss';

let eventComponent = {
  restrict: 'E',
  bindings: {selectedEvent: '<'},
  template,
  controller
};

export default eventComponent;



// WEBPACK FOOTER //
// ./client/app/components/events/event/event.component.js